import React, { useContext } from 'react';

import { format } from 'date-fns';

import { ApplicationUIContext, SummaryGrid } from '@yuhuinc/ui-library';
import { Typography } from 'antd';

import { getTranslatedString } from 'helpers/i18n';

import { CurrentApplicationContext } from '../../ApplicationOverview';

const { Title } = Typography;

const propertyText = getTranslatedString(
  'landlordPortal.applicationManagement.applicationOverview.overview.leaseSummary.property'
);
const unitText = getTranslatedString(
  'landlordPortal.applicationManagement.applicationOverview.overview.leaseSummary.unit'
);
const leaseStartDateText = getTranslatedString(
  'landlordPortal.applicationManagement.applicationOverview.overview.leaseSummary.leaseStartDate'
);
const leaseTermText = getTranslatedString(
  'landlordPortal.applicationManagement.applicationOverview.overview.leaseSummary.leaseTerm'
);

const LeaseSummary = () => {
  const { isMobile } = useContext(ApplicationUIContext);
  const application = useContext(CurrentApplicationContext);

  const data = [
    [propertyText, application.lease?.property_name],
    [unitText, application.lease?.unit_number],
    [
      leaseStartDateText,
      application.lease?.lease_start_date &&
        format(new Date(application.lease?.lease_start_date), 'yyyy-MM-dd'),
    ],
    [
      leaseTermText,
      `${application.lease?.lease_term_in_months} ${getTranslatedString('monthsPlural')}`,
    ],
  ];

  return (
    <>
      <Title level={isMobile ? 4 : 5}>
        {getTranslatedString(
          'landlordPortal.applicationManagement.applicationOverview.overview.leaseSummary'
        )}
      </Title>

      {application.lease ? <SummaryGrid values={data} /> : null}
    </>
  );
};

export default LeaseSummary;
